/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCrossRef.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cross-ref";

export class AutogenModelEdiCrossRef<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCrossRefFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCrossRef extends ModelRow<RowEdiCrossRefFields> {
	constructor(values?: Partial<RowEdiCrossRefFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCrossRefFields {
	company_id: string;
	edi_code: string;
	equipment_type_id: string;
	fgi_packaging_type_code: string;
	hdr_uid: number;
	id: string;
	la_business_unit: string;
	order_type_id: string;
	partner_id: string;
	revenue_code_id: string;
	seg_alloc_code: string;
	version: string;
}

